/* eslint-disable import/prefer-default-export */

const matchesAnyPattern = (patterns, value) => {
  if (!value || typeof value !== "string") return false;
  return patterns.some(pattern => pattern.test(value));
};

const MESSAGE_PATTERNS = [
  /CanceledError/i,
  /ERR_CANCELED/i,
  /canceled/i,
  // Action Cable reopen message
  /Existing connection must be closed before opening/i,
  // Bad chrome extension
  /ceCurrentVideo\.currentTime/i,
  // Mobile Firefox. Issue: https://github.com/mozilla-mobile/firefox-ios/issues/5818
  /webkit\.messageHandlers\.contextMenuMessageHandler\.postMessage/i,
  // Web analytics
  /sendMessage/i,
  // iframe errors
  /Exception invoking setProtocol/i,
  // iframe errors (e.g., https://vars.hotjar.com and other frames)
  /Blocked a frame with origin/i,
  // Google Translate extension
  // See: https://medium.com/@amir.harel/a-b-target-classname-indexof-is-not-a-function-at-least-not-mine-8e52f7be64ca
  /a\[b\]\.target\.className\.indexOf is not a function/i,
  // Browser network-fetch failures (navigation-away, network interruption, ad blockers, CORS).
  // Each browser surfaces the same underlying condition with a different message string.
  // Parity: request.js isNetworkError, log-upload-error.js, dropzone-error-event-tracker.js
  /^Failed to fetch$/i, // Chrome / Edge
  /^Load failed$/i, // Safari / WebKit
  /^NetworkError when attempting to fetch resource\.$/i, // Firefox
  // Cross-origin script errors sanitized by the browser (no stack, no file, no line).
  // See: https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror#notes
  /^Script error\.?$/i
];

const STACK_PATTERNS = [
  // Honeybadger uses `/unknown/` parity; this may also match `unknown:0:0:in`.
  /unknown/,
  /user-script/i,
  // Honeybadger tests these against `notice.stack` (not `notice.message`)
  /webkit-masked-url/i,
  /recaptcha/i,
  /chrome-extension/i,
  /safari-extension/i,
  /moz-extension/i,
  /ms-browser-extension/i,
  // Klarna third-party domain errors
  /klarnaservices\.com/i,
  // Treasure Data SDK errors (e.g. googletag race condition in fetchServerCookie callback)
  /treasuredata\.com/i,
  // GTM container internal errors (misconfigured tags/variables, not fixable from app code)
  /googletagmanager\.com\/gtm\.js/i
];

const USER_AGENT_PATTERNS = [/vuln_scan_by_trustedsite_com_halo_security/i];

export const shouldIgnoreError = (event, userAgentOverride) => {
  const error = event?.error;
  const message = error?.message || "";
  const stack = error?.stack || "";
  const userAgent =
    userAgentOverride ?? (typeof navigator !== "undefined" ? navigator.userAgent : "");

  // Check error name first (Honeybadger parity: notice.name === 'CanceledError')
  if (error?.name === "CanceledError") return true;
  if (matchesAnyPattern(MESSAGE_PATTERNS, message)) return true;
  if (matchesAnyPattern(STACK_PATTERNS, stack)) return true;
  if (matchesAnyPattern(USER_AGENT_PATTERNS, userAgent)) return true;

  // ignore known error coming from anonymous function that might be caused by injected code
  if (
    /<anonymous>/.test(stack) &&
    message === "Cannot read properties of undefined (reading 'campaign')"
  ) {
    return true;
  }

  return false;
};
